module.exports = "/_next/static/images/e31d92273ea5b97e329b99e6de454095-nubanker-tpm@3x.jpg";